module.exports = __webpack_public_path__ + "static/media/IMG_1475.594608d0.JPG";